import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[hasPermission]'
})
export class HasPermissionDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) { }

  @Input() set hasPermission(value: string) {
    const [screen, action] = value.split(':');
    if (this.checkPermission(screen, action)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  checkPermission(screen: string, action: string): boolean {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user?.user?.role === 'super_admin') {
      return true;
    }

    const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
    return Array.isArray(permissions) && permissions.some(
      p => p.screen_name === screen && p.action_name === action
    );
  }
}
